<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>{{ $t('teamInvite.teamTitle') }}</h3>

        <span>{{ $t('live.tishi') }}：{{ $t('live.liveDate') }}</span>
      </div>

      <div class="main">
        <!--提示-->
        <div class="point">
          <div class="title">{{ $t('common.importantremind') }}</div>
          <div class="content">
            {{ $t('teamInvite.tishi1') }}
            <br />
            {{ $t('teamInvite.tishi2') }}
          </div>
        </div>

        <!--搜索框-->
        <div class="item">
          <div class="search">
            <el-input v-model="search" clearable :placeholder="$t('teamInvite.placeholder1')"> </el-input>
            <el-button class="btn" @click="searchMember"> {{ $t('teamInvite.search') }}</el-button>
          </div>
        <el-button class="addmember btn" @click="add">{{ $t('teamInvite.addbuys') }}</el-button> 
        </div>

        <!--表格-->
        <div class="tab">
          <el-table
            :cell-style="{ padding: '0px' }"
            :data="tableData"
            :header-cell-style="setSellStyle"
            :row-style="{ height: '64px', color: '#333333' }"
            stripe
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="多选" type="selection" width="54" :selectable="checkSelectable"></el-table-column>

            <el-table-column :label="$t('card.name')" prop="name" width="80">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.name.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.name)"
                >
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('teamInvite.companyName')" prop="unitName" width="150">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.unitName.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.unitName)"
                >
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('teamInvite.companyAddress')" prop="unitAddress" width="200"></el-table-column>

            <el-table-column :label="$t('special.iphone')" prop="linkTelephone">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.linkTelephone.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.linkTelephone)"
                >
                </span>
              </template>
            </el-table-column>

            <!-- <el-table-column :label="$t('card.cardType')" prop="column14" width="120">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.column14.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.column14)"
                >
                </span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column :label="$t('card.IDnumber')" prop="column15" width="180">
              <template slot-scope="scope">
                <span class="aa" v-if="!scope.row.column15.includes('[')">{{ scope.row.column15 }}</span>
                <span
                  v-else
                  :style="{
                    color: scope.row.column15.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.column15)"
                >
                </span>
              </template>
            </el-table-column> -->

            <el-table-column :label="$t('teamInvite.departement')" prop="duty" width="180"></el-table-column>

            <el-table-column :label="$t('card.email')" prop="email">
              <template slot-scope="scope">
                <div
                  :style="{
                    color: matchEmail(scope.row.email) === false ? '#FF190C' : '#333',
                  }"
                >
                  {{ scope.row.email }}
                </div>
                <span v-if="matchEmail(scope.row.email) === false && scope.row.email != ''" style="color: #ff190c">邮箱格式错误</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('common.status')" prop="auditFlag" width="80">
              <template slot-scope="scope">
                <el-tooltip class="item1" effect="dark" :content="scope.row.cause" placement="top" :disabled="!scope.row.cause">
                  <span
                    :style="{
                      color: scope.row.auditFlag === '-1' ? '#FF190C' : '#333',
                    }"
                    >{{
                      scope.row.isSubmit === 1
                        ? ''
                        : scope.row.auditFlag === '0'
                        ? $t('card.pass')
                        : scope.row.auditFlag === '-1'
                        ? $t('card.noPass')
                        : scope.row.auditFlag === '2'
                        ? $t('card.under')
                        : ''
                    }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column :label="$t('common.operate')" align="center">
              <template slot-scope="scope">
                <el-button class="edit" type="text" @click="openEdit(scope.row)"
                  ><i class="el-icon-edit-outline"> {{ $t('common.edit') }}</i></el-button
                >
                <el-button type="text" @click="deletMsg(scope.row.id)"
                  ><i class="el-icon-delete">{{ $t('common.delete') }}</i></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

  <div class="download">
          <div class="item">
            <p>
              {{ $t('card.tishi1')
              }}<span class="template"
                ><a href="./team.xlsx" download="团体邀请人员名单模板.xlsx"> {{ $t('card.tishi2') }}</a></span
              >
            </p>
            <p>
              <el-upload
                class="upload-demo"
                :headers="getToken()"
                :action="uploadAudienceUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handSuccess"
              >
                <el-button class="upload">{{ $t('card.uploadFile') }}</el-button>
              </el-upload>
            </p>
          </div>
          <div class="aa">
            <el-button class="btn submit" @click="submitVerify()">{{ $t('common.submit') }}</el-button>
          </div>
        </div> 
      
      </div>
    </el-card>

    <!-- 新增弹框开始 -->
    <div class="editMsg">
      <el-dialog :visible.sync="saveVisible" center width="500px" :close-on-click-modal="false">
        <span slot="title" class="dialog-footer"> {{ $t('teamInvite.addbuys') }} </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form ref="saveContent" :model="saveContent" label-width="120px" label-position="top" :rules="rules">
              <el-form-item :label="$t('card.name') + '：'" prop="name">
                <el-input v-model="saveContent.name" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder')" type="age"></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitName') + '：'" prop="unitName">
                <el-input
                  v-model="saveContent.unitName"
                  autocomplete="off"
                  maxlength="50"
                  show-word-limit
                  :placeholder="$t('card.placeholder1')"
                  type="age"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitAddress') + '：'" prop="unitAddress">
                <el-input v-model="saveContent.unitAddress" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder8')" type="age"></el-input>
              </el-form-item>

              <!-- <el-form-item :label="$t('card.cardType') + '：'" prop="column14">
                <el-select v-model="saveContent.column14" :placeholder="$t('card.placeholder2')">
                  <el-option :label="$t('teamInvite.idcart')" value="身份证"></el-option>
                  <el-option :label="$t('teamInvite.certificate')" value="军官证"></el-option>
                  <el-option :label="$t('teamInvite.passport')" value="护照"></el-option>
                </el-select>
              </el-form-item> -->

              <!-- <el-form-item :label="$t('card.IDnumber') + '：'" prop="column15">
                <el-input v-model="saveContent.column15" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder3')" type="age"></el-input>
              </el-form-item> -->

              <el-form-item :label="$t('card.duty') + '：'" prop="duty">
                <el-input v-model="saveContent.duty" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder6')" type="age"></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.iphone') + '：'" prop="linkTelephone">
                <el-input v-model="saveContent.linkTelephone" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder7')" type="age"></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input v-model="saveContent.email" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder9')" type="age"></el-input>
              </el-form-item>

              <el-row class="save">
                <el-button @click="sumitAdd()"> {{ $t('common.save') }}</el-button>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>

    <!-- 编辑弹框开始 -->
    <div class="editMsg">
      <el-dialog ref="editdialog" :visible.sync="editVisible" center width="500px" :close-on-click-modal="false">
        <span slot="title" class="dialog-footer"> {{ $t('teamInvite.editbuy') }} </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form ref="editContent" :model="editContent" :rules="rules">
              <el-form-item :label="$t('card.name') + '：'" prop="name">
                <el-input v-model="editContent.name" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder3')" type="age"></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitName') + '：'" prop="unitName">
                <el-input
                  v-model="editContent.unitName"
                  autocomplete="off"
                  maxlength="50"
                  show-word-limit
                  :placeholder="$t('card.placeholder1')"
                  type="age"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.unitAddress') + '：'">
                <el-input v-model="editContent.unitAddress" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder8')" type="age"></el-input>
              </el-form-item>

              <!-- <el-form-item :label="$t('card.cardType') + '：'" prop="column14">
                <el-select v-model="editContent.column14" :placeholder="$t('card.placeholder2')" @change="oneditSelectedDrug($event, editContent.column14)">
                  <el-option :label="$t('teamInvite.idcart')" value="身份证"></el-option>
                  <el-option :label="$t('teamInvite.certificate')" value="军官证"></el-option>
                  <el-option :label="$t('teamInvite.passport')" value="护照"></el-option>
                </el-select>
              </el-form-item> -->

              <!-- <el-form-item :label="$t('card.IDnumber') + '：'" prop="column15">
                <el-input v-model="editContent.column15" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder3')" type="age"></el-input>
              </el-form-item> -->

              <el-form-item :label="$t('card.duty') + '：'" prop="duty">
                <el-input v-model="editContent.duty" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder6')" type="age"></el-input>
              </el-form-item>

              <el-form-item :label="$t('card.iphone') + '：'" prop="linkTelephone">
                <el-input v-model="editContent.linkTelephone" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder7')" type="age"></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input v-model="editContent.email" autocomplete="off" maxlength="100" :placeholder="$t('card.placeholder9')" type="age"></el-input>
              </el-form-item>
              <el-row class="save">
                <el-button @click="sumitEdit()"> {{ $t('common.save') }}</el-button>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 编辑弹框结束 -->
    <!------------失败提示信息--------------------->
    <div class="noticeMsg">
      <el-dialog :visible.sync="overflowVisible" width="30%" center :close-on-click-modal="false">
        <span slot="title" class="dialog-footer">{{ $t('teamInvite.inforTishi') }}</span>
        <div class="content">
          {{ $t('teamInvite.inforTishi2') }}
          <br />
          <div style="color:red;margin-top:5px">{{ submitFailMessage }}</div>
        </div>
        <el-row class="sure"
          ><el-button @click="overflowVisible = false">{{ $t('navbar.sure') }}</el-button></el-row
        >
      </el-dialog>
    </div>
    <!-----------成功提示信息---------------------->
    <div class="noticeMsg">
      <el-dialog :visible.sync="successVisible" width="30%" center :close-on-click-modal="false">
        <span slot="title" class="dialog-footer">{{ $t('teamInvite.inforTishi3') }}</span>
        <div class="content">
          {{ $t('teamInvite.inforTishi4') }}
        </div>
        <el-row class="sure"
          ><el-button @click="successVisible = false">{{ $t('navbar.sure') }}</el-button></el-row
        >
        <!--  表单结束 -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getLists, addAudience, getItem, editItem, delItem, submitList } from '../../../api/groupInvite.js';
import { uploadExcelAudience } from '../../../utils/common.js';
import { auth } from '../../../api/common.js';

export default {
  name: 'groupInvite',
  created() {
    this.init();
  },
  data() {
    return {
      uploadAudienceUrl: uploadExcelAudience(),

      search: '', //搜索框

      //表格数据
      tableData: [],

      //编辑弹框标志位
      editVisible: false,

      //编辑弹框的具体内容
      editContent: {
        name: '', //姓名
        unitName: '', //单位名称
        unitAddress: '', //单位地址
        column14: '', //证件类型
        column15: '', //证件号
        duty: '', //职务
        linkTelephone: '', //手机号
        email: '', //邮箱
      },

      //保存弹框的具体内容
      saveVisible: false,

      //保存弹框的具体内容
      saveContent: {
        name: '', //姓名
        unitName: '', //单位名称
        unitAddress: '', //单位地址
        column14: '身份证', //证件类型
        column15: '', //证件号
        duty: '', //职务
        linkTelephone: '', //手机号
        email: '', //邮箱
      },

      editId: '',
      currentSelectLists: [],

      //提交失败
      overflowVisible: false,
      //提交成功
      successVisible: false,
      submitFailMessage: '',
    };
  },

  methods: {
    split(current) {
      if (current.includes('[')) {
        const arr = current.split('[');
        const result = arr[0] + '<br>' + arr[1].substr(0, arr[1].length - 1);
        return result;
      } else {
        return current;
      }
    },
    //动态进行验证
    oneditSelectedDrug(item) {
      /*    let validateColumn15 = (rule, value, callback) => {
      const type = this.saveContent.column14 || this.editContent.column14;
      if (!type) {
        callback(new Error('请先选择证件类型'));
      }
      if (type === '身份证') {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value) === false) {
          callback(new Error('身份证号码不符合规范，请重新输入'));
        }
      }
      callback()
      };
     if (item == "身份证") {

      this.rules.column15 = this.rules.column15.filter((item)=>{
         return item.message == '证件号码不能为空';
      })
      this.rules.column15.push( { validator:validateColumn15 });
      console.log('长度是：',this.rules.column15.length);

    }else{
       this.rules.column15 = this.rules.column15.filter((item)=>{
         return item.message == '证件号码不能为空';
      })
      console.log('长度是：',this.rules.column15.length);
} */
    },

    //获取买家的列表数据
    async getAllList() {
      const params = {
        query: this.search,
      };
      try {
        const { data } = await getLists(params);
        if (data.code === 200) {
          this.tableData = data.data.list;
        }
      } catch (err) {
        this.$message.error(err);
      }
    },

    //搜索筛选数据
    searchMember() {
      this.getAllList();
    },

    //初始化数据
    init() {
      this.getAllList();
    },

    // 上传excel文件成功函数
    handSuccess(file) {
      // console.log('上传的文件是：', file);
      if (file.code == 200) {
        // 文件上传成功
        this.$message({
          message: this.$t('dialog.message27'),
          type: 'success',
        });
        //刷新数据
        this.getAllList();
      }
    },

    //新增保存,点击保存的时候，进行身份校验
    sumitAdd() {
      this.$refs.saveContent.validate((valid) => {
        if (valid) {
          // this.idAuth(); //执行提交验证操作
          this.submitForm();
        } else {
          this.$message.error(this.$t('dialog.message18'));
        }
      });
    },
 // 目前新增买家不需要身份证号 
    // 新增实名身份验证
    async idAuth() {
      //params,姓名,证件号
      const params = {
        name: this.saveContent.name,
        idCard: this.saveContent.column15,
      };

      //如果是身份证就进行核验，否则就不核验
      if (this.saveContent.column14 == '身份证') {
        try {
          //调用接口进行验证
          const { data } = await auth(params);
          if (data.code == 200) {
            this.submitForm();
          } else {
            this.$message.error(this.$t('dialog.message22'));
          }
        } catch (err) {}
      } else {
        this.submitForm(); //进行接口上传
      }
    },

    //新增买家信息最终提交
    async submitForm() {
      try {
        const { data } = await addAudience(this.saveContent);
        if (data.code == 200) {
          this.saveVisible = false;

          this.$nextTick(() => {
            this.$refs.saveContent.resetFields(); //等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.resetFields()，去除验证
          });

          this.getAllList();
          this.$message({
            message: this.$t('dialog.addbuy'),
            type: 'success',
          });
        }
      } catch (err) {
        this.$message.error(this.$t('dialog.bugceil'));
      }
    },

    //获取token
    getToken() {
      const a = localStorage.getItem('token');
      let token = {};
      token.token = a;
      return token;
    },

    //打开新增弹框
    add() {
      // this.saveContent = { column14: '身份证' };
      this.saveVisible = true;
    },

    //-----------------------------------编辑相关函数-----------------------------------------

    //关闭编辑框
    closeEdit(formRef) {
      this.editVisible = false;
    },

    //编辑审核
    sumitEdit() {
      this.$refs.editContent.validate((valid) => {
        if (valid) {
          // 目前没有身份验证 直接上传即可
          // this.idAuth1(); //执行提交操作
          this.saveMsg();
        } else {
          this.$message.error(this.$t('dialog.message18'));
        }
      });
    },

    //进行身份验证
    async idAuth1() {
      const params = {
        name: this.editContent.name,
        idCard: this.editContent.column15,
      };
      // console.log("身份证信息",this.editContent.column14);
      //如果是身份证就进行核验，否则就不核验
      if (this.editContent.column14 == '身份证') {
        try {
          //调用接口进行验证
          const { data } = await auth(params);
          if (data.code == 200) {
            this.saveMsg();
          } else {
            this.$message.error(this.$t('dialog.message22'));
          }
        } catch (err) {}
      } else {
        this.saveMsg(); //进行接口上传
      }
    },

    //打开编辑框
    async openEdit(row) {
      this.editVisible = true;
      this.editId = row.id;
      const params = { id: row.id };
      try {
        const { data } = await getItem(params);
        if (data.code === 200) {
          this.editContent = data.data;
        }
      } catch (err) {
        this.$message.error(err);
      }
    },

    //编辑保存函数
    async saveMsg() {
      const obj = {
        id: this.editId, //当前观众id
        name: this.editContent.name, //姓名
        unitName: this.editContent.unitName, //单位名称
        unitAddress: this.editContent.unitAddress, //单位地址
        linkTelephone: this.editContent.linkTelephone, //联系电话
        duty: this.editContent.duty, //职务
        email: this.editContent.email, //电子邮箱，比如 example@qq.com
        column14: this.editContent.column14, //证件类型
        column15: this.editContent.column15, //证件号
      };
      try {
        const { data } = await editItem(obj);
        if (data.code === 200) {
          this.editVisible = false;

          this.$message({
            message: this.$t('dialog.editbug'),
            type: 'success',
          });
          this.getAllList();
        }
      } catch (err) {
        this.$message.error(err);
      }
    },

    //表格数据删除
    async deletMsg(id) {
      const params = { id };
      this.$confirm(this.$t('dialog.confirmDelete'), this.$t('dialog.attention'), {
        confirmButtonText: this.$t('dialog.sure'),
        cancelButtonText: this.$t('dialog.cancel'),
        customClass: 'myClass',
      }).then(async () => {
        const { data } = await delItem(params);
        if (data.code === 200) {
          this.$message({
            message: this.$t('dialog.deletbug'),
            type: 'success',
          });
          this.getAllList();
        }
      });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //圆角处理
    setSellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === '多选') {
        return 'background:#FDC400;color:#333333;border-top-left-radius:5px;font-weight: 500;height: 42px;padding: 0;';
      }
      if (column.label === '操作') {
        return 'background:#FDC400;color:#333333;border-top-right-radius:5px;font-weight: 500;height: 42px;padding: 0;';
      } else {
        return 'background:#FDC400;color:#333333;font-weight: 500;height: 42px;padding: 0;';
      }
    },
    checkSelectable(row) {
      return row.auditFlag === '-1' || row.isSubmit === 1;
    },

    //匹配邮箱
    matchEmail(email) {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (reg.test(email) === false) {
        //邮箱不合格
        return false;
      } else {
        return true;
      }
    },

    //复选框变化
    handleSelectionChange(selection) {
      this.currentSelectLists = selection;
      // console.log(selection);
    },

    // 提交买家信息审核
    async submitVerify() {
      const arr = [];
      // console.log(this.currentSelectLists);
      this.currentSelectLists.map((item) => {
        arr.push(item.id);
      });

      if (this.currentSelectLists.length == 0) {
        this.$message.warning(this.$t('dialog.message28'));
        return false;
      }

      try {
        const { data } = await submitList(arr);
        if (data.code == 0 && data.data.status == 1) {
          this.overflowVisible = true;
          this.submitFailMessage = data.data.msg;
        } else {
          this.getAllList();
          this.successVisible = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    rules() {
      var validateColumn15 = (rule, value, callback) => {
        let type;
        if (this.editId) {
          type = this.editContent.column14;
        } else {
          type = this.saveContent.column14;
        }
        if (!type) {
          callback(new Error(this.$t('card.rules.papersType')));
        }
        if (type == '身份证') {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (reg.test(value) === false) {
            callback(new Error(this.$t('card.rules.idcard')));
          }
        }
        callback();
      };

      var validatorLinkTelephone = (rule, value, callback) => {
        const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (reg.test(value) === false) {
          callback(new Error(this.$t('card.rules.phoneLength')));
        } else {
          callback();
        }
      };

      var validatorEmail = (rule, value, callback) => {
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (reg.test(value) === false) {
          callback(new Error(this.$t('card.rules.email')));
        }
        callback();
      };
      return {
        name: [{ required: true, message: this.$t('card.rules.name') }],
        unitName: [{ required: true, message: this.$t('card.rules.company') }],
        column14: [{ required: true, message: this.$t('card.rules.column11') }],
        column15: [{ required: true, message: this.$t('card.rules.column12') }, { validator: validateColumn15 }],
        linkTelephone: [{ required: true, message: this.$t('card.rules.phone') }, { validator: validatorLinkTelephone }],
        email: [{ required: true, message: this.$t('card.rules.emailRequire') }, { validator: validatorEmail }],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  //margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .el-card {
    min-height: calc(100vh - 74px - 40px);
  }

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    align-items: center;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 20px;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 20px 30px 0;
    //display: flex;

    //提示
    .point {
      width: 100%;
      height: 96px;
      background: #f6f6f7;
      padding: 10px 30px;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-weight: 400;
        color: #ff190c;
        line-height: 22px;
      }

      .content {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 10px;
      }
    }

    //搜索及新增
    .item {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      //输入框
      .search {
        display: flex;
      }

      .addmember {
        background-color: #ffffff;
        color: #666666;
      }
    }

    //表格
    .tab {
      margin-top: 17px;
    }

    //上传
    .download {
      .item {
        margin-top: 17px;
        display: flex;
        justify-content: flex-start;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        ::v-deep .upload {
          background-color: #ffffff;
          color: #666666;
          height: 32px;
          padding: 0;
          font-weight: 400;
        }

        p {
          line-height: 28px;
        }
        .upload-demo {
          margin-left: 52px;
        }
        .template {
          a {
            color: #006fb8;
          }
        }
      }
    }
  }

  //弹窗
  .editMsg {
    //编辑框的弹框信息
    .dialog-footer {
      width: 100%;
      position: relative;
      top: -5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      //标题
      .instance {
        margin: 0px 17px 0px 17px;
      }
    }
  }
}

.noticeMsg {
  //编辑框的弹框信息

  .dialog-footer {
    height: 36px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: left;
  }
  .content {
    border-bottom: 1px solid #00000017;
    padding-bottom: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    span {
      color: #006fb8;
      padding-left: 5px;
    }
  }
  .failContent {
    padding-bottom: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: red;
  }
  .sure {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
  }
}
</style>

<style scoped>
.apply >>> .el-dialog__close {
  color: #ffffff;
}
.sure {
  display: flex;
  justify-content: flex-end;
}
.sure >>> .el-button {
  width: 65px;
  height: 32px;
  background: #006fb8;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-right: 30px;
  line-height: 0px;
}
.dialog-footer {
  position: relative;
  top: -5px;
}

.noticeMsg .content {
  padding-left: 40px;
}

.instance >>> .el-form-item {
  display: flex;
}

.instance >>> .el-form-item__label {
  width: 180px;
  text-align: right;
}

.instance >>> .el-input__inner {
  width: 280px;
}
.el-dialog__wrapper >>> .el-dialog--center {
  text-align: left !important;
}

.el-dialog__wrapper >>> .dialog-footer {
  margin-left: 20px;
}

.instance >>> .el-form-item__error {
  position: absolute;
  left: 0px;
  top: 40px;
  padding-top: 0px;
}

.instance >>> .el-form-item {
  margin-bottom: 20px !important;
}

.el-form--label-top >>> .el-form-item__label {
  padding: 0;
  box-sizing: border-box;
}
.search >>> .btn {
  margin-left: 15px;
  background: #006fb8;
  color: white;
}

.el-form-item >>> .el-input {
  width: 240px;
}

.el-form-item >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.el-form-item >>> .el-input__icon {
  line-height: 32px;
}

[class*=' el-icon-'],
[class^='el-icon-'] {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006fb8;
  line-height: 20px;
  margin: 0px 8px;
}

.edit {
  border-right: 1px solid #e9e9e9;
}

.tab >>> .el-button {
  padding: 0px;
  border-radius: 0px;
}

.tab >>> .el-button + .el-button {
  margin-left: 0px;
}

.el-dialog__wrapper >>> .el-dialog__header {
  background: #006fb8;
}

.save {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(0, 0, 0, 0.09);
  padding-top: 15px;
  padding-right: 30px;
}

.save >>> .el-button {
  width: 65px;
  height: 32px;
  text-align: center;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 0px;
}

.el-dialog__wrapper >>> .el-dialog__body {
  padding: 20px 0px 15px !important;
}

/* >>> .el-dialog__close {
  color: #ffffff;
}

>>> .editMsg .el-input {
  width: 90%;
}

>>> .editMsg .el-select {
  width: 90%;
}

>>> .el-select .el-input {
  width: 100%;
}

>>> .upload.el-button {
  width: 103px;
}

>>> .submit.btn.el-button {
  margin: 30px 0;
} */

.el-form-item >>> .el-dialog__close {
  color: #ffffff;
}

.el-form-item >>> .editMsg .el-input {
  width: 90%;
}

.el-form-item >>> .editMsg .el-select {
  width: 90%;
}

.el-form-item >>> .el-select .el-input {
  width: 100%;
}

.el-form-item >>> .upload.el-button {
  width: 103px;
}

.el-form-item >>> .submit.btn.el-button {
  margin: 30px 0;
}

.aa >>> .el-button {
  background-color: #006fb8 !important;
  color: white;
  padding: 7px 20px;
}
.upload-demo >>> .upload {
  width: 90px !important;
}
</style>
